import React, { useState, useEffect } from 'react';
import { useTheme } from '../../../assets/contexts/ThemeContext';
import CustomSelect from '../../../components/widgets/CustomSelect';

/**
 * 우측 사이드바 타입 제어 컴포넌트
 * 원본: right-sidebar-type-control.html
 */
const RightSidebarTypeControl = () => {
  const { themeConfig, set } = useTheme();
  const currentThemeConfig = themeConfig || {};
  const [widthValue, setWidthValue] = useState(String(currentThemeConfig.rightSidebarWidth || 420));

  // themeConfig가 변경되면 로컬 상태 동기화
  useEffect(() => {
    const configWidth = currentThemeConfig.rightSidebarWidth || 420;
    setWidthValue(String(configWidth));
  }, [currentThemeConfig.rightSidebarWidth]);

  return (
    <div id="right-sidebar-type-control-section">
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
          <label style={{ fontWeight: 'bold', color: '#333', fontSize: '13px', margin: 0, flex: 1 }}>🎨 우측 사이드바 디자인 테마:</label>
          <button
            type="button"
            className="theme-help-btn"
            data-target="right-sidebar-type-control-section"
            title="이 항목으로 이동"
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '11px',
              width: '20px',
              height: '20px',
              padding: 0,
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
              e.target.style.borderColor = 'var(--theme-color-primary)';
              e.target.style.color = 'var(--theme-color-primary)';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#ddd';
              e.target.style.color = '#666';
            }}
          >
            ?
          </button>
        </div>
        <CustomSelect
          value={currentThemeConfig.rightSidebarType || 'simple'}
          onChange={(newType) => {

            // 사이드바가 열려있는지 먼저 확인
            const sidebarElement = document.querySelector('.sidebar-common-active');
            const isOpen = sidebarElement && sidebarElement.classList.contains('inside');
            const wrapper = document.querySelector('.main-wrapper');

            // 테마 설정 업데이트
            set('rightSidebarType', newType);

            // 사이드바가 열려있으면 즉시 반영 (닫히지 않도록)
            if (typeof window !== 'undefined' && window.sidebarCommon && typeof window.sidebarCommon.loadSidebarType === 'function') {
              // requestAnimationFrame을 사용하여 DOM 업데이트 후 실행
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  window.sidebarCommon.loadSidebarType(newType);

                  // 사이드바가 열려있었으면 다시 열린 상태 유지
                  if (isOpen && sidebarElement) {
                    sidebarElement.classList.add('inside');
                    if (wrapper) {
                      wrapper.classList.add('overlay-active');
                    }
                  }
                });
              });
            }
          }}
          isSearchable={false}
          isClearable={false}
          options={[
            { value: 'simple', label: '1) 심플한 컨셉' },
            { value: 'modern', label: '2) 모던한 컨셉' },
            { value: 'vibrant', label: '3) 화려한 컨셉' },
          ]}
          styles={{
            control: (base, state) => ({
              ...base,
              width: '100%',
              minHeight: 36,
              fontSize: 13,
              borderRadius: 4,
              borderColor: state.isFocused ? '#86b7fe' : '#ddd',
              marginBottom: 18,
            }),
            valueContainer: (base) => ({ ...base, padding: '0 12px' }),
            indicatorsContainer: (base) => ({ ...base, height: 36 }),
          }}
        />
      </div>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
          <label style={{ fontSize: '12px', color: '#666', fontWeight: 500 }}>너비 (px):</label>
          <button
            type="button"
            onClick={() => {
              setWidthValue('420');
              set('rightSidebarWidth', 420);
            }}
            style={{
              background: 'transparent',
              border: '1px solid #ddd',
              color: '#666',
              fontSize: '10px',
              padding: '2px 8px',
              borderRadius: '3px',
              cursor: 'pointer'
            }}
          >
            리셋
          </button>
        </div>
        <div style={{ position: 'relative' }}>
          <input
            type="number"
            value={widthValue}
            onChange={(e) => {
              const inputValue = e.target.value;
              // 로컬 상태 업데이트 (입력 중에도 반영)
              setWidthValue(inputValue);

              // 유효한 값이면 themeConfig 업데이트
              if (inputValue !== '') {
                const value = parseInt(inputValue, 10);
                if (!isNaN(value) && value >= 200 && value <= 800) {
                  set('rightSidebarWidth', value);
                }
              }
            }}
            onBlur={(e) => {
              const inputValue = e.target.value;
              const value = parseInt(inputValue, 10);
              if (isNaN(value) || value < 200 || value > 800) {
                const currentValue = currentThemeConfig.rightSidebarWidth || 420;
                setWidthValue(String(currentValue));
                set('rightSidebarWidth', currentValue);
              } else {
                // 유효한 값이면 확정
                set('rightSidebarWidth', value);
              }
            }}
            style={{
              width: '100%',
              padding: '6px 10px',
              paddingRight: '35px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '12px',
              fontFamily: 'monospace',
              textAlign: 'center'
            }}
            min="200"
            max="800"
            placeholder="420"
          />
          <div style={{ position: 'absolute', right: '8px', bottom: '6px', fontSize: '11px', color: '#999', pointerEvents: 'none' }}>px</div>
        </div>
        <div style={{ fontSize: '10px', color: '#999', marginTop: '4px', lineHeight: 1.4 }}>
          우측 사이드바의 너비를 조절합니다. (200px ~ 800px)
        </div>
      </div>
    </div>
  );
};

export default RightSidebarTypeControl;

